const { createContext, useContext } = window.React;

const TransitionContext = createContext(null);

export function TransitionProvider({ value, children }) {
    return (
        <TransitionContext.Provider value={value}>
            {children}
        </TransitionContext.Provider>
    );
}

export function useTransition() {
    const context = useContext(TransitionContext);
    if (!context) {
        throw new Error("useTransition must be used within a TransitionProvider");
    }
    return context;
}

